import { create } from 'zustand'

interface UIStore {
  disableNewButton: boolean
  isSystemFolder: boolean
  setDisableNewButton: (disable: boolean) => void
  setIsSystemFolder: (isSystem: boolean) => void
}

export const useUIStore = create<UIStore>(set => ({
  disableNewButton: false,
  isSystemFolder: false,
  setDisableNewButton: (disable: boolean) => set({ disableNewButton: disable }),
  setIsSystemFolder: (isSystem: boolean) => set({ isSystemFolder: isSystem }),
}))
